import secondaryComponents from "../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import primaryComponents from "../../../../../components/primaryComponents";
import {
  IntegratedDeviceForm,
  IntegratedDeviceTable,
} from "../../../../../components/secondaryComponents/ExternallyIntegratedPayments";
import { PlusIcon } from "../../../../../assets/svgIcons";
import { RoutedModal } from "../../../../../components/common";
import { useInterswitchDevices } from "./useInterswitchDevices";

const InterswitchDevices = () => {
  const {
    search,
    terminals,
    metaDetails,
    isLoadingTerminals,
    isAddTerminal,
    storeList,
    setIsAddTerminal,
    gotoPage,
    filterBySearch,
    filterByStoreId,
  } = useInterswitchDevices();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Market - Interswitch"
      description="Manage interswitch connections"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={` ${globalStyles.pagePaddings} ${globalStyles.pageColumnGaps}`}
        >
          <div>
            <h4 className="mb-0">Manage Interswitch</h4>
            <p>
              Manage and connect lumi app to interswitch terminals to collect
              payment seemlessly in your store
            </p>
          </div>

          <div className={globalStyles.pageHeaders}>
            <p>{metaDetails?.total} Terminals</p>
            <primaryComponents.Button
              classNames={"btn btn--primary"}
              onClick={() => setIsAddTerminal(true)}
            >
              <PlusIcon className="mr-1" />
              Add Terminals
            </primaryComponents.Button>
          </div>

          <div className={`${globalStyles.tableWrapper}`}>
            <div className={`${globalStyles.tableHeader}`}>
              <primaryComponents.SearchField
                placeholder="Search by terminal "
                trigger={(value) => filterBySearch(value)}
                value={search.get("query") !== null ? search.get("query") : ""}
                triggerOnInput={true}
                showsearchBtn
                classNames={`${globalStyles.searchField}`}
              />
              <div className="ml-auto" style={{ width: "200px" }}>
                <primaryComponents.SelectField
                  options={[{ name: "All stores", id: null }, ...storeList]}
                  idKey="id"
                  nameKey="name"
                  onChange={(value) => {
                    filterByStoreId(value);
                  }}
                  value={
                    storeList?.find(
                      (store) => `${store?.id}` === search.get("store_id"),
                    )?.name || "Select store"
                  }
                  floatError={false}
                />
              </div>
            </div>

            {/* table section */}
            <secondaryComponents.LoaderHelper
              isLoading={isLoadingTerminals}
              classNames="mt-5"
            >
              <IntegratedDeviceTable
                deviceList={terminals}
                gotoPage={gotoPage}
                metaDetails={metaDetails}
              />
            </secondaryComponents.LoaderHelper>
          </div>

          <RoutedModal
            isActive={isAddTerminal}
            width={600}
            headerTitle="Add Terminal"
            // headerDescription="Select a terminal to receive transfer payment"
            closeModal={() => setIsAddTerminal(false)}
            style={{ height: "auto" }}
          >
            <IntegratedDeviceForm closeModal={() => setIsAddTerminal(false)} />
          </RoutedModal>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
export default InterswitchDevices;
